import { Badge, Button, DatePicker, Dropdown, Form, Input, Select } from 'antd'
import { inject, observer } from 'mobx-react'
import React, { useEffect, useMemo, useState } from 'react'
import { checkValidFormFieldValue } from '../../utils/helper'
import { Tuning2OutlineIcon } from '../../components/AppIcon'
import { DATE_FORMAT_LIST, ISO_DATE_FORMAT } from '../../constants'
import moment from 'moment'

const { Option } = Select

const DocumentVBPCPageAdvanceFilterV2 = props => {
  const [showFilter, setShowFilter] = useState(false)

  const { documentStore } = props

  const { filterVBPC } = documentStore || {}

  const [form] = Form.useForm()
  const values = Form.useWatch([], form)
  const { setFieldsValue } = form

  const appliedFilterCount = useMemo(() => {
    let count = 0
    const hasValue = val => val && String(val).trim() !== ''

    if (hasValue(filterVBPC.document_number)) count++
    if (hasValue(filterVBPC.document_name)) count++
    if (
      hasValue(filterVBPC.from_issue_date) &&
      hasValue(filterVBPC.to_issue_date)
    )
      count++
    if (hasValue(filterVBPC.issue_level)) count++
    if (hasValue(filterVBPC.contruction_board)) count++
    if (hasValue(filterVBPC.status)) count++

    return count
  }, [filterVBPC])

  useEffect(() => {
    if (showFilter) {
      setFieldsValue({
        document_name: filterVBPC.document_name,
        document_number: filterVBPC.document_number,
        date_issued:
          filterVBPC.from_issue_date && filterVBPC.to_issue_date
            ? [
                moment(filterVBPC.from_issue_date),
                moment(filterVBPC.to_issue_date),
              ]
            : undefined,
        issue_level: filterVBPC.issue_level,
        contruction_board: filterVBPC.contruction_board,
        status: filterVBPC.status,
      })
    }
  }, [filterVBPC, setFieldsValue, showFilter])

  const onFinish = values => {
    Object.keys(values).forEach(key => {
      if (typeof values[key] === 'string') {
        values[key] = values[key].trim()
      }
    })
    const { date_issued } = values

    if (date_issued && date_issued.length === 2) {
      values.from_issue_date = moment(date_issued[0]).format(ISO_DATE_FORMAT)
      values.to_issue_date = moment(date_issued[1]).format(ISO_DATE_FORMAT)
    }

    documentStore.setFilterVBPC({
      contruction_board: values.contruction_board,
      document_name: values.document_name,
      document_number: values.document_number,
      from_issue_date: values.from_issue_date,
      to_issue_date: values.to_issue_date,
      status: values.status,
      issue_level: values.issue_level,
    })
    onToggleFilter()
  }

  const onToggleFilter = () => {
    setShowFilter(prev => !prev)
  }

  const hasFormValue = Object.values(values || {}).some(
    checkValidFormFieldValue
  )

  return (
    <Dropdown
      open={showFilter}
      onOpenChange={onToggleFilter}
      trigger={['click']}
      dropdownRender={() => (
        <div className="custom-page-filter-dropdown-container ">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <div className="form-elements">
              <Form.Item name={'document_name'} label={'Tên văn bản'}>
                <Input allowClear placeholder={'Nhập tên văn bản'} />
              </Form.Item>
              <Form.Item
                name={'document_number'}
                label={'Số quyết định ban hành'}>
                <Input allowClear placeholder={'Nhập số quyết định ban hành'} />
              </Form.Item>
              <Form.Item label={'Ngày ban hành'} name={'date_issued'}>
                <DatePicker.RangePicker
                  format={DATE_FORMAT_LIST}
                  style={{ width: '100%' }}
                />
              </Form.Item>
              <Form.Item name={'issue_level'} label={'Cấp ban hành'}>
                <Input allowClear placeholder={'Nhập cấp ban hành'} />
              </Form.Item>{' '}
              <Form.Item
                name={'contruction_board'}
                label={'Ban chủ trì xây dựng'}>
                <Input allowClear placeholder={'Nhập ban chủ trì xây dựng'} />
              </Form.Item>
              <Form.Item name={'status'} label={'Trạng thái'}>
                <Select
                  allowClear
                  showSearch
                  placeholder={'Trạng thái'}
                  filterOption={true}
                  optionFilterProp={'name'}>
                  {['Đã bãi bỏ', 'Hết hiệu lực', 'Còn hiệu lực'].map(
                    (status, index) => {
                      return (
                        <Option key={index} name={status} value={index + 1}>
                          {status}
                        </Option>
                      )
                    }
                  )}
                </Select>
              </Form.Item>
            </div>
            <div
              style={{
                marginTop: '5px',
                display: 'flex',
                gap: '10px',
                alignItems: 'center',
                justifyContent: hasFormValue ? 'space-between' : 'center',
                padding: '0 20px',
              }}>
              <Button
                className="custom-ant-button"
                type="primary"
                htmlType="submit">
                Áp dụng
              </Button>
              <Button
                className="custom-ant-button"
                htmlType="button"
                onClick={onToggleFilter}>
                Đóng
              </Button>

              <Button
                className="custom-ant-button"
                style={{
                  display: hasFormValue ? 'flex' : 'none',
                  marginLeft: 'auto',
                }}
                htmlType="reset"
                onClick={() => {
                  form.resetFields()
                  documentStore.resetFilter()
                  onToggleFilter()
                }}>
                Xóa
              </Button>
            </div>
          </Form>
        </div>
      )}
      placement="bottomRight">
      <Badge count={appliedFilterCount} offset={[-6, -3]}>
        <Button
          className="custom-page-filter-dropdown-btn"
          icon={
            <Tuning2OutlineIcon
              style={{
                width: 16,
                height: 16,
              }}
            />
          }
        />
      </Badge>
    </Dropdown>
  )
}

export default inject(
  'authorityStore',
  'documentStore',
  'loadingAnimationStore'
)(observer(DocumentVBPCPageAdvanceFilterV2))
